import Drift from 'drift-zoom';
import jQuery from "jquery";
window.$ = window.jQuery = jQuery;
window.components.products = {
    selector: "section[products]",
    init: function () {
        this.events();
        
let produtoDetalhe = $('.produtoDetalhe');
if(produtoDetalhe.length > 0) {

    if($(window).width() > 1024) {
        new Drift(document.querySelector("img.zoom"), {
            paneContainer: document.querySelector("p")
        });
    }

    }
    },
    events: function () {
        $(this.selector).find("[product-id]").on("click", this.onClickProduct);
    },
    onClickProduct: function (e) {
        e.preventDefault();
        const id = $(e.target).closest("[product-id]").attr("product-id");
        window.components.modalProduct.open(id);
    },
    
};
